import React from 'react';
import { arrayOf, bool, func, number, oneOfType, shape, string, } from 'prop-types';
import setClass from '../../common/set-class';
import Chip from '../chip/chip';
import Flex from '../layout';
import Icon from '../icon';
const ValueContainer = (props) => {
    const { disabled, isOpen, onRemoveValue, placeholder, toggleOpen, values, } = props;
    const noValues = values?.length <= 0;
    const handleRemoveValue = (e, option, allValues) => {
        e.stopPropagation();
        onRemoveValue(option, allValues);
    };
    const renderValues = () => {
        if (!values || noValues) {
            return (React.createElement("p", { className: "b-async-select-multi-search__inactive-msg" }, placeholder));
        }
        return values.map(({ label, value }) => (React.createElement("div", { key: `b-async-select-multi-search__option-${value}`, className: "b-async-select-multi__value-remove" },
            React.createElement(Chip, { onRightIconClick: (e) => handleRemoveValue(e, { value, label }, values), kind: "secondary", iconRight: disabled ? '' : 'xmark', text: label, className: "b-async-select-multi__value" }))));
    };
    const renderValueContainer = () => (React.createElement(Flex, { justify: "flex-start", align: "center", className: setClass([
            'b-async-select-multi__value-container',
            disabled ? 'b-async-select-multi__value-container--disabled' : '',
            isOpen ? 'b-async-select-multi__value-container--active' : '',
            !noValues ? 'b-async-select-multi__value-container-filled' : '',
        ]), wrap: true },
        renderValues(),
        React.createElement(Icon, { name: "angle-down", size: "sm", className: setClass([
                'b-select__icon',
                isOpen ? '' : 'b-select__icon--closed',
            ]) })));
    return (React.createElement("div", { tabIndex: 0, className: "b-async-select-multi__value-container-toggle", onClick: toggleOpen }, renderValueContainer()));
};
ValueContainer.propTypes = {
    disabled: bool,
    isOpen: bool,
    onRemoveValue: func.isRequired,
    placeholder: string,
    toggleOpen: func.isRequired,
    values: arrayOf(shape({ label: string, value: oneOfType([string, number]) })),
};
ValueContainer.defaultProps = {
    disabled: false,
    isOpen: false,
    placeholder: 'Select Option',
    values: [],
};
export default ValueContainer;
